<template>
  <v-container fluid>
    <div class="mt-12 bienvenue-dans-lapp">
      Bienvenue dans l'application des importations privées
    </div>

    <v-row justify="space-around">
      <v-col cols="12" xs="1" md="6" order-md="4">
        <v-img
          src="@/assets/vin_image3.jpg"
          max-width="600"
          max-height="400"
          aspect-ratio="1"
          class="ma-3"
        />
      </v-col>
      <v-col cols="12" xs="1" md="4" align-self="center">
        <v-container>
          <v-row class="mx-3">
            <v-text-field
              v-model="codeUsager"
              autofocus
              :label="$t('login_codeUsager')"
              :error-messages="codeUsagerErrors"
              :disabled="sending"
              @keyup.enter="submit"
              @input="$v.codeUsager.$touch()"
              @blur="$v.codeUsager.$touch()"
            />
          </v-row>
          <v-row class="mx-3">
            <v-text-field
              v-model="motDePasse"
              hint="Au moins 8 caracteres"
              :label="$t('login_pwd')"
              :error-messages="motDePasseErrors"
              :append-icon="showPwd ? 'visibility' : 'visibility_off'"
              :type="showPwd ? 'text' : 'password'"
              :disabled="sending"
              @keyup.enter="submit"
              @input="$v.motDePasse.$touch()"
              @blur="$v.motDePasse.$touch()"
              @click:append="showPwd = !showPwd"
            />
          </v-row>

          <v-row justify="end" class="mx-3">
            <v-btn :to="{ name: 'mdpOublie' }" text x-small>
              {{ $t('mdp_oublie_lien') }}
            </v-btn>
          </v-row>

          <v-row justify="center">
            <v-btn
              medium
              color="primary"
              style="text-transform: none;"
              class="pl-16 pr-16 mt-8"
              @click="submit"
            >
              {{ $t('login_connecter_bouton') }}
            </v-btn>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  data() {
    return {
      codeUsager: null,
      motDePasse: null,
      showPwd: false,
      sending: false
    }
  },
  validations: {
    codeUsager: {
      required
    },
    motDePasse: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(32)
    }
  },
  computed: {
    rowOrColumn() {
      const binding = {}
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true
      return binding
    },
    codeUsagerErrors() {
      const errors = []
      if (!this.$v.codeUsager.$dirty) return errors
      !this.$v.codeUsager.required && errors.push(this.$t('msg_obligatoire'))
      return errors
    },
    motDePasseErrors() {
      const errors = []
      if (!this.$v.motDePasse.$dirty) return errors
      !this.$v.motDePasse.required && errors.push(this.$t('msg_obligatoire'))
      !this.$v.motDePasse.minLength &&
        errors.push(this.$t('msg_lg_mini', { nb: 8 }))
      !this.$v.motDePasse.maxLength &&
        errors.push(this.$t('msg_lg_maxi', { nb: 32 }))
      return errors
    }
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.login()
      }
    },
    login() {
      this.sending = true
      axios
        .post('/identification/agent', {
          codeUsager: this.codeUsager,
          motDePasse: this.motDePasse
        })
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.$store.dispatch('login', resp.resultat)
              // Force GET request on index.html on successful login
              window.location.href = '/accueil'
              break

            case 'S001':
              msg = 'Code usager inconnu ou mot de passe incorrect'
              console.log(msg)
              this.$store.dispatch('afficherWarning', msg)
              break

            case 'S002':
              msg =
                "La connection n'est pas possible, veuillez communiquer avec la SAQ"
              console.log(msg)
              this.$store.dispatch('afficherWarning', msg)
              break

            case 'S003':
              msg = "Le mot de passe n'est pas valide"
              console.log(msg)
              this.$store.dispatch('afficherWarning', msg)
              break

            case 'X001':
              msg =
                "La connection n'est pas possible pour le moment, veuillez essayer de nouveau un peu plus tard"
              console.log(msg)
              this.$store.dispatch('afficherWarning', msg)
              break

            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => {
          this.sending = false
        })
    },
    clear() {
      this.$v.$reset()
      this.codeUsager = null
      this.motDePasse = null
    }
  }
}
</script>

<style scoped>
span {
  color: #343232;
}

div {
  color: #343232;
}

.bienvenue-dans-lapp {
  height: 94px;
  width: 650px;
  color: #343232;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
}

/* Seulement pour IE 11 */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .ieMaxWidth90 {
    text-align: justify;
    max-width: 90vw; /* 90% view width */
  }
  .ieMaxWidth40 {
    max-width: 40vw; /* 40% view width */
    text-align: justify;
  }
}
</style>
